import { useCallback } from 'react'
import Page from 'rui/widgets/Page'
import Thin from 'components/layout/Thin'
import Panel, { PanelHeading, PanelSubheading } from 'components/layout/Panel'
import { Body2, Caption } from 'components/layout/text'
import idFaceImg from 'images/01-id-face.png'
import Spacer from 'components/misc/Spacer'
import styled from 'styled-components'
import { ExternalLink } from 'components/layout/links'
import { BasicButton } from 'components/layout/buttons'
import { sendNativeMessage } from 'util/native'
import { LocalizedRichText, LocalizedText } from 'localization'

const Img = styled.img`
  width: 70%;
`

const List = styled.div`
  display: block;
  width: fit-content;
  margin: 0 auto;
`

const ListItem = styled.div`
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 1.2rem;
  }
`

const ListItemIndex = styled.span`
  background-color: ${(props) => props.theme.colors.primaryLight};
  color: ${(props) => props.theme.colors.primaryBase};
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 50%;
  margin-right: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`

const P = styled.p`
  font-size: 1.1rem;
  text-align: left;
  line-height: normal;
  font-weight: 500;
`

const stepKeys = [
  'dweb_account_driving_info_license_info_capture_front_license',
  'dweb_account_driving_info_license_info_capture_back_license',
  'dweb_account_driving_info_license_info_take_selfie',
]

const VerifyIdentity = () => {
  const handleClick = useCallback(() => {
    sendNativeMessage({ type: 'OPEN_IDV' })
  }, [])

  // console.log('rendering v-id')

  return (
    <Page>
      <Thin>
        <Panel>
          <PanelHeading id="idv-heading">
            <LocalizedText translationKey="dweb_verify_identity" />
          </PanelHeading>
          <PanelSubheading id="idv-subheading">
            <LocalizedText translationKey="dweb_verify_identity_help_protect_our_community_prevent_fraudulent_users_from" />
          </PanelSubheading>

          <Spacer height="3.2rem" />
          <Img id="idv-face-image" src={idFaceImg} />
          <Spacer height="3.2rem" />

          <List id="idv-steps">
            {stepKeys.map((translationKey, index) => (
              <ListItem key={translationKey}>
                <ListItemIndex>
                  <Caption color="primaryDark" weight="500">
                    {index + 1}
                  </Caption>
                </ListItemIndex>
                <Body2>
                  <LocalizedText translationKey={translationKey} />
                </Body2>
              </ListItem>
            ))}
          </List>

          <Spacer height="1.6rem" />

          <P id="idv-agreement-paragraph">
            <LocalizedRichText
              translationKey="dweb_verify_identity_biometric_consent"
              params={{
                privacyPolicyLink: (
                  <ExternalLink href="https://www.roadie.com/privacy">
                    <LocalizedText translationKey="dweb_verify_identity_privacy_policy" />
                  </ExternalLink>
                ),
              }}
            />
          </P>

          <Spacer height="1.6rem" />

          <BasicButton id="idv-start-verification-btn" target="_blank" mode="primary" onClick={handleClick}>
            <LocalizedText translationKey="dweb_verify_identity_start_verification" />
          </BasicButton>
        </Panel>
      </Thin>
    </Page>
  )
}

export default VerifyIdentity
